
import I18n from './I18n'

export default {
  mixins: [
    I18n,
  ],

  computed: {
    order () {
      return this.$store.state.orders.current
    },
  },

  methods: {
    checkMinQuantity (item, add = 1) {
      if (this.order.invalidMinQuantity(item, add)) {
        this.$store.dispatch('alert/snackInfo', this.__('minQuantityNotice'))
      }
    },
  },
}
